"use client"

import { FileVideoCamera } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FileVideoCameraIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FileVideoCameraIcon = component(Icon)({ as: FileVideoCamera })
